import { render, staticRenderFns } from "./EmojiContainer.vue?vue&type=template&id=8c60c278"
import script from "./EmojiContainer.vue?vue&type=script&lang=ts"
export * from "./EmojiContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports